import { useLanguage } from "@/contexts/LanguageContext";
import { cn } from "@/lib/utils";
import { useNavigate, useLocation } from "react-router-dom";

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1 text-xs font-medium tracking-wide">
      <button
        onClick={() => setLanguage("en")}
        className={cn(
          "px-2 py-1 transition-colors duration-200",
          language === "en"
            ? "text-foreground"
            : "text-muted-foreground hover:text-foreground/70"
        )}
        aria-label="English"
      >
        ENG
      </button>
      <span className="text-muted-foreground/50">|</span>
      <button
        onClick={() => setLanguage("de")}
        className={cn(
          "px-2 py-1 transition-colors duration-200",
          language === "de"
            ? "text-foreground"
            : "text-muted-foreground hover:text-foreground/70"
        )}
        aria-label="Deutsch"
      >
        DE
      </button>
    </div>
  );
}
